import { getAmplitudeInstance } from '../amplitudeHelpers';
import CustomRouteCardActionTaken from '../enums/CustomRouteCardActionTaken';
import CustomRoutePrivacyLevelAction from '../enums/CustomRoutePrivacyLevelAction';

type logCustomRouteDetailsActionTakenParams = {
  action: CustomRouteCardActionTaken;
  custom_route_id: number;
  owned_by_user: boolean;
  poi_id?: number;
  privacy_level_changed?: CustomRoutePrivacyLevelAction;
  waypoint_id?: number;
};

/**
 * User takes an action on the custom route page.
 * @param params - Attributes to log with the amplitude event
 * @param params.action - the action that the user took on the custom route details page
 * @param params.custom_route_id - custom route id associated with the viewed card
 * @param params.owned_by_user - Boolean: TRUE if the viewed custom route is created by the user
 * @param params.poi_id - only fired if user performs poi clicked action
 * @param params.privacy_level_changed - only fired if user performs privacy level changed action
 * @param params.waypoint_id - only fired if user performs waypoint clicked action
 */
const logCustomRouteDetailsActionTaken = (
  { action, custom_route_id, owned_by_user, poi_id, privacy_level_changed, waypoint_id }: logCustomRouteDetailsActionTakenParams,
  callback?: () => void
) => {
  getAmplitudeInstance().logEvent(
    'custom route details action taken',
    {
      action,
      'custom route id': custom_route_id,
      'owned by user': owned_by_user,
      'poi id': poi_id,
      'privacy level changed': privacy_level_changed,
      'waypoint id': waypoint_id
    },
    callback
  );
};

export default logCustomRouteDetailsActionTaken;
